module.exports = __webpack_public_path__ + "53be6cd495217147d9ef8a67e844cb37.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-role-type/sp-role-type.html
// module id = 1129
// module chunks = 0